import { api as managementApi } from "../api";
import { Account, AccountSearchParams } from "./types";
import { CollectionResponse } from "../../types";

export const accountApi = managementApi.injectEndpoints({
    endpoints: (build) => ({
        getAccount: build.query<Account, number>({
            query: (id: number) => ({
                url: `api/v1/accounts/${id}`,
            }),
        }),
        getAccounts: build.query<CollectionResponse<Account>, AccountSearchParams>({
            query: (params = {}) => ({
                url: "api/v1/accounts",
                params: {
                    page: params.page,
                    per_page: params.perPage,
                    "filter[code]": params.filter?.code,
                    "filter[code_exact]": params.filter?.codeExact,
                },
            }),
        }),
    }),
});

export const { useGetAccountQuery, useGetAccountsQuery } = accountApi;
